module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.data.datasets), function(item) {
    return _c('td', {
      key: item,
      attrs: {
        "width": "90px"
      }
    }, [(typeof(item[1]) != 'object') ? _c('span', {
      staticClass: "color",
      style: ({
        'background-color': _vm.generateTitleColor(item.label) + ' !important'
      })
    }) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.choices), function(choice, index) {
    return _c('tr', {
      key: choice
    }, [_c('td', {
      staticClass: "align-left"
    }, [_vm._v(_vm._s(choice))]), _vm._v(" "), _vm._l((_vm.data.datasets[index].data), function(result) {
      return _c('td', {
        key: result,
        staticClass: "align-center"
      }, [_vm._v("\n          " + _vm._s(result) + "\n          "), (_vm.isPercentage) ? _c('span', [_vm._v("%")]) : _vm._e()])
    })], 2)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f912d68","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/charts/StackedChartLegend.vue
// module id = 3374
// module chunks = 3